"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./Layout.css");
var _awsAmplify = require("aws-amplify");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _ScrollToTop = _interopRequireDefault(require("../components/ScrollToTop"));
var _Footer = _interopRequireDefault(require("./Footer"));
var _Header = _interopRequireDefault(require("./Header"));
var _Main = _interopRequireDefault(require("./Main"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Layout = props => {
  const {
    hash
  } = (0, _reactRouterDom.useLocation)();
  const navigate = (0, _reactRouterDom.useNavigate)();
  (0, _react.useEffect)(() => {
    const stopListening = _awsAmplify.Hub.listen('auth', _ref => {
      let {
        payload: {
          event,
          data
        }
      } = _ref;
      if (event === 'customOAuthState') {
        console.debug("customOAuthState :: redirecting to \"".concat(data, "\""));
        navigate(data);
      }
    });
    return () => {
      stopListening();
    };
  }, [navigate]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hash && /*#__PURE__*/_react.default.createElement(_ScrollToTop.default, null), /*#__PURE__*/_react.default.createElement(_Header.default, {
    subtitle: props.subtitle,
    memberNavItems: props.memberNavItems,
    relatedNavItems: props.relatedNavItems,
    siteNavItems: props.siteNavItems
  }, props.title), /*#__PURE__*/_react.default.createElement(_Main.default, null, props.children), /*#__PURE__*/_react.default.createElement(_Footer.default, {
    actions: props.footerNavItems
  }));
};
Layout.defaultProps = {};
Layout.propTypes = {
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string,
  relatedNavItems: _propTypes.default.array.isRequired,
  siteNavItems: _propTypes.default.array.isRequired,
  footerNavItems: _propTypes.default.array.isRequired
};
var _default = exports.default = Layout;